import React from "react";
import { CircularProgress } from "@mui/material";
import RenderText from "../Text/RenderText";
import { convertToKebabCase } from "src/helpers/helperFunctions";

export interface IGradientBtnProps {
  ButtonText: string;
  loader?: boolean;
  onPress?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "button" | "submit" | "reset"; // Type adjusted to possible button types
  btnExtraStyle?: React.CSSProperties; // Correct type for CSS styles
  extraClass?: string;
  fontsizeBtn?: string;
  fontfamilyBtn?: string;
  isOutline?: boolean;
  id?: string;
  idIndex?: string;
  disabled?: boolean;
  title?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
const GradientBtn: React.FC<IGradientBtnProps> = ({
  ButtonText = "",
  loader = false,
  onPress = (event: React.MouseEvent<HTMLButtonElement>) => {},
  type = "button",
  btnExtraStyle = {}, // Missing comma added here
  extraClass = "",
  fontsizeBtn = "font-size-18px",
  fontfamilyBtn = "font-Lexend-Medium",
  isOutline = false,
  id = "",
  idIndex = "",
  disabled = false,
  title = "",
  leftIcon = null,
  rightIcon = null,
}) => {
  const loaderStyle = {
    width: 14,
    height: 14,
    color: "#fff",
  };
  return (
    <button
      className={`${
        isOutline
          ? "gradient-btn bg-white text-[#00443F] border border-[#00443F]"
          : "gradient-btn theme-gradient-green-bottom text-white"
      }  rounded-full h-fit outline-none whitespace-nowrap flex items-center justify-center gap-3 ${disabled ? "cursor-not-allowed opacity-50" : ""} ${fontsizeBtn} ${fontfamilyBtn} ${extraClass}`}
      disabled={disabled || loader}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled && !loader) {
          onPress(e as any);
        }
      }}
      type={type}
      style={{ ...btnExtraStyle }}
      id={id ? id : convertToKebabCase(ButtonText) + idIndex}
      title={title}
    >
      {leftIcon && leftIcon}
      <RenderText>{ButtonText}</RenderText>
      {rightIcon && rightIcon}
      {loader && <CircularProgress style={loaderStyle} />}
    </button>
  );
};

export default GradientBtn;
